import {
    iconRequest,
    iconClient,
    iconReports,
    iconParameters,
    iconCalculator,
    iconReportsDefault,
    iconParametersDefault,
    iconSearch,
} from '../defaultValues';

const data = {
    role_824b0e1802c04d3fbcb2c0abca0fa1e2: [
        {
            id: 'gogo',
            icon: iconRequest,
            label: 'Solicitudes',
            to: '/app/credits',
        },
        {
            id: 'searcRequest',
            icon: iconSearch,
            label: 'Buscar Solicitud',
            to: '/app/reports/searchRequest',
        },
        {
            id: 'secondmenu',
            icon: iconClient,
            label: 'Clientes',
            to: '/app/clients',
        },
        {
            id: 'blankpage',
            icon: iconReports,
            label: 'Reportes',
            to: '/app/blank-page',
            subs: [
                {
                    icon: iconReportsDefault,
                    label: 'Seguros Voluntarios',
                    to: '/app/clients',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Cartera',
                    to: '/app/collection/lista',
                },
                {
                    icon: iconReportsDefault,
                    label: 'General',
                    to: '/app/clients',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Paz y salvo',
                    to: '/app/clients',
                },
            ],
        },
        {
            id: 'docs',
            icon: iconParameters,
            label: 'Parámetros',
            to: '/app/clients',
            subs: [
                {
                    icon: iconParametersDefault,
                    label: 'Aliados',
                    to: '/app/aliados',
                },
                {
                    icon: iconParametersDefault,
                    label: 'Concesionarios',
                    to: '/app/concesionarios',
                },
            ],
        },
        {
            id: 'simulador-credito',
            icon: iconCalculator,
            label: 'Simulador de Crédito',
            to: '/app/calculator',
            subs: [
                {
                    icon: iconCalculator,
                    label: 'Simulador de Créditos',
                    to: '/app/calculator',
                },
                {
                    icon: iconCalculator,
                    label: 'Calculadora Refinanciación',
                    to: '/app/credits',
                },
                {
                    icon: iconCalculator,
                    label: 'Calculadora Restructuración',
                    to: '/app/credits',
                },
            ],
        },
    ],
};
export default data;
